import { type JSX, type ReactNode, useEffect } from 'react';

import { applyThemeToDocument, useThemeStore } from '@/shared/lib/theme';

interface ThemeProviderProps {
  children: ReactNode;
}

/**
 * Dark mode is token remapping only: this writes one attribute and every
 * component follows, because none of them know a colour by name (§8.2).
 */
export function ThemeProvider({ children }: ThemeProviderProps): JSX.Element {
  const theme = useThemeStore((state) => state.theme);

  // synchronizing with the document, which React does not own
  useEffect(() => {
    applyThemeToDocument(theme);
  }, [theme]);

  return children as JSX.Element;
}
